import React from "react";
import styles from "./styles.module.scss";

export function Row({ label, children, gap }) {
  return (
    <div className={styles.root} style={{ gap }}>
      <div className={styles.label}>{label}:</div>
      {children}
    </div>
  );
}
